module.exports = __webpack_public_path__ + "img/menuIcon3.7f8d923a.png";